import apiClient from "./client";
import type { SubscriptionPlan } from "@/types";

interface BackendSubscriptionPlan {
  id: string;
  price: number;
  currency: string;
  period: "month" | "year";
  trialPeriodDays: number;
}

function mapSubscriptionPlan(plan: BackendSubscriptionPlan): SubscriptionPlan {
  return {
    id: plan.id,
    price: plan.price,
    currency: plan.currency,
    interval: plan.period === "year" ? "yearly" : "monthly",
    trialPeriodDays: plan.trialPeriodDays,
  };
}

export const subscriptionsApi = {
  getPlans: async (): Promise<SubscriptionPlan[]> => {
    const response = await apiClient.get<{ prices: BackendSubscriptionPlan[] }>(
      "/subscriptions/prices"
    );
    return response.data.prices.map(mapSubscriptionPlan);
  },

  startCheckoutSession: async (priceId: string): Promise<{ url: string }> => {
    const response = await apiClient.post<{ url: string }>(
      "/subscriptions/start-checkout-session",
      {
        priceId,
      }
    );
    return response.data;
  },

  getCustomerPortalUrl: async (): Promise<{ url: string }> => {
    const response = await apiClient.get<{ url: string }>(
      "/subscriptions/customer-portal"
    );
    return response.data;
  },
};
